<template>
  <v-dialog
    v-model="editarDescansoMedicoDialog"
    max-width="60vw"
    max-height="50vh"
    persistent
  >
    <v-card>
      <v-card-title
        class="text-h5 justify-center"
        style="color: teal; font-weight: bold"
      >
        {{
          !nuevoDescansoMedico
            ? `Editando descanso médico de:`
            : 'Agregar descanso médico para:'
        }}
      </v-card-title>
      <v-card-subtitle style="color: teal;" class="text-h5">
        {{ `${persona.nombre}` }}
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <v-text-field
                label="Nro. de CITT"
                v-model="descansoMedicoAEditar.citt"
                :rules="nameRules"
                :disabled="!nuevoDescansoMedico"
              />
              <v-text-field
                label="Fecha de inicio"
                v-model="descansoMedicoAEditar.fecha_inicio"
                type="date"
                :rules="dateRules"
              />
              <v-text-field
                label="Fecha de fin"
                v-model="descansoMedicoAEditar.fecha_fin"
                type="date"
                :rules="dateRules"
              />
            </v-col>

            <v-col>
              <v-autocomplete
                label="Tipo de descanso médico"
                v-model="descansoMedicoAEditar.tipo_descanso"
                :items="tiposDeDescanso"
                item-text="nombre"
                :rules="nameRules"
              />
              <v-text-field
                label="Centro de salud"
                v-model="descansoMedicoAEditar.centro_salud"
              />
              <v-text-field
                label="Diagnóstico"
                v-model="descansoMedicoAEditar.diagnostico"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-textarea
              outlined
              label="Observaciones"
              v-model="descansoMedicoAEditar.observaciones"
            />
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          color="blue darken-1"
          text
          @click="closeDialog"
          :disabled="deshabilitarBotonGuardar"
          >Cancelar</v-btn
        >
        <v-btn
          color="success"
          text
          @click="validate"
          :disabled="deshabilitarBotonGuardar"
          >Guardar</v-btn
        >
        <v-btn
          color="red"
          text
          @click="eliminarDescansoMedico"
          v-show="!nuevoDescansoMedico"
          :disabled="deshabilitarBotonGuardar"
          >Eliminar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

import { actualizarAsistencia } from '@/api/persons/actualizarAsistencia.js';
import { obtenerAsistenciaPorRangoDeFechas } from '@/api/persons/obtenerAsistenciaPorRangoDeFechas.js';
import { editUserInfo } from '@/api/persons/editUserInfo.js';
import { editarAsistencia } from '@/api/persons/editarAsistencia.js';
import routeToLoginIfTokenIsExpired from '@/utils/routeToLoginIfTokenIsExpired.js';

export default {
  name: 'EditarDescansoMedico',
  dmOriginal: {},
  data() {
    return {
      deshabilitarBotonGuardar: false,
      descansoMedicoAEditar: {
        citt: '',
        fecha_inicio: '',
        fecha_fin: '',
        tipo_descanso: '',
        centro_salud: '',
        diagnostico: '',
        observaciones: '',
      },
      valid: true,
      tiposDeDescanso: [
        { nombre: 'Accidente de trabajo' },
        { nombre: 'Enfermedad común' },
      ],
      nameRules: [
        (v) => !!v || 'Campo requerido',
        (v) => (v && v.length >= 3) || 'Mínimo 3 caracteres',
      ],
      dateRules: [(v) => !!v || 'Campo requerido'],
    };
  },
  props: {
    descansoMedico: Object,
    persona: Object,
    nuevoDescansoMedico: Boolean,
  },
  watch: {
    editarDescansoMedicoDialog() {
      this.$nextTick(function() {
        this.$refs.form.resetValidation();
      });
    },
    descansoMedico() {
      this.descansoMedicoAEditar = this.descansoMedico;
      this.$options.dmOriginal = { ...this.descansoMedico };
    },
  },
  computed: {
    ...mapState(['editarDescansoMedicoDialog']),
  },
  methods: {
    closeDialog() {
      this.$options.dmOriginal = {};
      this.deshabilitarBotonGuardar = false;
      this.$store.state.editarDescansoMedicoDialog = false;
    },
    showSuccessAlert() {
      this.$swal.fire({
        title: `Operación realizada correctamente!`,
        text: '',
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      });
    },
    showErrorAlert() {
      this.$swal.fire({
        title: `No se puede modificar este descanso médico!`,
        text: '',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      });
    },
    showDateErrorAlert() {
      this.$swal.fire({
        title: `Error`,
        text:
          'La fecha de fin no puede ser menor a la fecha de inicio del descanso médico!',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      });
    },
    showDeleteAlert() {
      this.$swal
        .fire({
          title: `Atención!`,
          text: 'Está seguro que desea eliminar este descanso médico?',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'No',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.deshabilitarBotonGuardar = true;
            const { fecha_inicio, fecha_fin, citt } = this.$options.dmOriginal;
            this.persona.descansos_medicos = this.persona.descansos_medicos.filter(
              (descanso) => descanso.citt !== citt
            );

            await this.actualizarAsistencias(fecha_inicio, fecha_fin, 'Falto');

            const { error, message, tokenExpired } = await editUserInfo(
              this.persona
            );

            if (error) {
              //do something
            }
            if (tokenExpired) {
              routeToLoginIfTokenIsExpired(this);
            }
            if (message) {
              this.showSuccessAlert();
              this.closeDialog();
            }
          }
        });
    },
    async eliminarDescansoMedico() {
      this.showDeleteAlert();
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.deshabilitarBotonGuardar = true;
        const { fecha_inicio, fecha_fin } = this.descansoMedicoAEditar;
        const {
          fecha_inicio: fecha_inicioOriginal,
          fecha_fin: fecha_finOriginal,
        } = this.$options.dmOriginal;
        if (fecha_fin < fecha_inicio) {
          this.showDateErrorAlert();
          return;
        }

        if (this.nuevoDescansoMedico) {
          this.persona.descansos_medicos.push(this.descansoMedicoAEditar);
        } else {
          this.persona.descansos_medicos.map((descanso) => {
            if (descanso.citt === this.descansoMedicoAEditar.citt) {
              descanso = this.descansoMedicoAEditar;
            }
            return descanso;
          });
        }

        const { error: errorActualizando, message } = await editUserInfo(
          this.persona
        );

        if (errorActualizando) {
          //do something
        }
        if (message) {
          if (
            fecha_inicio !== fecha_inicioOriginal ||
            fecha_fin !== fecha_finOriginal
          ) {
            //si la fecha_inicioOriginal === '' entonces solo actualizar con las fechas del descanso a editar
            if (fecha_inicioOriginal === '') {
              await this.actualizarAsistencias(
                fecha_inicio,
                fecha_fin,
                'Descanso médico'
              );
              this.showSuccessAlert();
              this.closeDialog();
              return;
            }
            await this.actualizarAsistencias(
              fecha_inicioOriginal,
              fecha_finOriginal,
              'Falto'
            );
            await this.actualizarAsistencias(
              fecha_inicio,
              fecha_fin,
              'Descanso médico'
            );
            this.showSuccessAlert();
            this.closeDialog();
          } else {
            await this.actualizarAsistencias(
              fecha_inicio,
              fecha_fin,
              'Descanso médico'
            );
            this.showSuccessAlert();
            this.closeDialog();
          }

          //si las fechas cambiaron se deben actualizar las asistencias... reemplazar lo antiguo con Falto y volver a reemplazar por DM, o hay una mejor forma?

          //se actualizó el campo descansos_medicos de la persona
        }
      }
    },
    async actualizarAsistencias(fecha_inicio, fecha_fin, tipo_jornada) {
      const {
        error,
        tokenExpired,
        asistencias,
      } = await obtenerAsistenciaPorRangoDeFechas(
        moment(fecha_inicio).tz('America/Lima'),
        moment(fecha_fin).tz('America/Lima')
      );
      // } = await obtenerAsistenciaPorRangoDeFechas(fecha_inicio, fecha_fin);
      if (error) {
        //do something
      }
      if (tokenExpired) {
        routeToLoginIfTokenIsExpired(this);
      }
      if (asistencias) {
        for (let asistencia in asistencias) {
          let personaFound = asistencias[asistencia].personal.find(
            (person) => person.doi.toString() === this.persona.doi.toString()
          );
          if (!personaFound) {
            //modificar como sería la asistencia y luego hacer el push
            this.persona.disponible = true;
            if (tipo_jornada !== 'Falto') {
              this.persona.disponible = false;
            }
            this.persona.tipo_jornada = tipo_jornada;
            asistencias[asistencia].personal.push(this.persona);
            const {
              error: errorEditandoAsistencia,
              message: asistenciaEditada,
            } = await editarAsistencia(asistencias[asistencia]);
            if (errorEditandoAsistencia) {
              //do something
            }
            if (asistenciaEditada) {
              //do something
            }
          } else {
            //   personaFound.disponible = false
            let registroDeAsistenciaActualizado = {
              user_id: this.persona._id,
              doi: this.persona.doi,
              fecha_asistencia: asistencias[asistencia].fecha_asistencia,
              tipo_jornada,
              hora_programada: '',
              hora_inicio_jornada: '',
              hora_fin_jornada: '',
              hora_inicio_almuerzo: '',
              hora_fin_almuerzo: '',
            };
            const {
              error: errorEditandoAsistencia,
            } = await actualizarAsistencia(registroDeAsistenciaActualizado);
            if (errorEditandoAsistencia) {
              //do something
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.dialog-container {
  overflow: scroll;
}
</style>
